module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "menu"
  }, [_c('ul', {
    staticClass: "unstyled"
  }, _vm._l((_vm.menuItems), function(item, index) {
    return _c('li', {
      key: index
    }, [_c('router-link', {
      class: _vm.currentItem == item ? 'active' : null,
      attrs: {
        "to": {
          name: _vm.baseLink,
          params: {
            alias: item.alias
          }
        }
      }
    }, [_vm._v(_vm._s(item.title))])], 1)
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-162d3a4d","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Projects/ProjectsMenu.vue
// module id = 904
// module chunks = 1